module.exports = __webpack_public_path__ + "img/information-selected.eaeec31b.svg";